module.exports = __webpack_public_path__ + "img/homework-lesson-black.6d836cb1.svg";